module.exports = __webpack_public_path__ + "img/pos6-tit.ed9a4b95.png";